


<template>
  <!-- 耕雲導師年谱初稿 -->
  <div class="firstDraft flex-center">
    <div class="tableStyle" v-html="content.news_content">

    </div>
    <!-- <table border="1" cellspacing="0" class="tableStyle">
      <tr>
        <th class="tableVirMidd f80 W2">{{$t('articleYear')}}</th>
        <th class="tableVirMidd f80 W3">{{$t('articleAge')}}</th>
        <th class="tableVirMidd f80">{{$t('articleEvent')}}</th>
      </tr>
      <tr v-for="(item,index) in 10" :key="index">
        <td class="tableVirMidd">1924</td>
        <td class="tableVirMidd">01歲</td>
        <td class="tableVirMidd td_content">農曆五月一日出生於天津市，乳名大有， 學名連元，字仲三。農曆五月一日出生於天津市，乳名大有， 學名連元，字仲三。農曆五月一日出生於天津市，乳名大有， 學名連元，字仲三。</td>
      </tr>
    </table> -->
  </div>
</template>

<script>
import {getChronicle} from '../../api/apis'
  // import barF5 from "../../components/barF5";
  export default {
    name: "",
    components: {
      // barF5
    },
    props: ['cateId'],
    data() {
      return {
        content:{}
      };
    },
    methods: {
      linkToDetail(item){

        this.$router.push({path:'/detail'})
      },
      setTable(){
        // let table = document.getElementsByTagName('table')[0],
        // tr = document.getElementsByTagName('tr'),
        // td = document.getElementsByTagName('td');
        // table.border = "1";
        // // table.className='tableStyle';
        // console.log('td tr',table,td,tr);
        // // for(let item of tr){
        // //   item.className ='tableVirMidd';
        // // }
        // // for(let item of td){
        // //   item.className ='tableVirMidd';
        // // }
        
      }
    },
    mounted(){
      getChronicle(this.cateId).then(res => {
        res.news_content = res.news_content.replace(/16px/g,'0.85rem');
        res.news_content = res.news_content.replace(/<table /g,'<table border="1px" style="max-width:20rem;"');
        this.content = res;

        // setTimeout(function(){
        //   _this.setTable();
        // },1000)
      });
      //重新设置表格颜色
      
    }
  };
</script>

<style scoped>
  .firstDraft {
    color: #333333;
    font-size: 0.85rem !important;
  }

  .tableStyle {
    width: 100%;
    /* text-align: center; */
    margin: 0.64rem;

  }


  .tableVirMidd {
    display: table-cell;
    vertical-align: middle;
    line-height: 1rem;
  }

  table {
    border: 1px solid #999999 !important;
  }

  th {
    border: 1px solid #999999;
 
    height: 3rem;
  }

  td {
    border: solid #999999;
    border-width: 1px 1px 1px 1px;
    height: 2.5rem;
  }
  .td_content{
    padding:1rem;
    text-align: left;
  }
  .f80 {
    font-size: 0.8rem;
  }
  .W2{
    width: 2.5rem;
  }
  .W3{
    width: 3rem;
  }
</style>